document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href.includes("?code-only")) {
    document.querySelectorAll(".field").forEach(field => {
      // conditions to hide field
      const hasTextInput = field.querySelector('input[type="text"]')
      const hasPhoneInput = field.querySelector('input[type="tel"]')
      const hasSelect = field.querySelector("select")
      const hasFileInput = field.querySelector('input[type="file"]')
      const hasTextarea = field.querySelector("textarea")
      const hasProvince = field.querySelector("#AddressProvinceContainer")

      // Check if field contains the approval code input
      const hasApprovalCode = field.querySelector("#application_approval_code")

      // Hide field if it has a text input or select but not the approval code
      if (
        (hasProvince ||
          hasTextInput ||
          hasSelect ||
          hasPhoneInput ||
          hasFileInput ||
          hasTextarea) &&
        !hasApprovalCode
      ) {
        field.style.display = "none"
      }
    })
    document.querySelectorAll(".ap-help").forEach(helpElement => {
      helpElement.style.display = "none"
    })
    document.querySelectorAll("input").forEach(input => {
      input.removeAttribute("required")
    })
    document.querySelectorAll("textarea").forEach(input => {
      input.removeAttribute("required")
    })
  }
})
